import { render, staticRenderFns } from "./connectCard.vue?vue&type=template&id=07340ff0&scoped=true&"
import script from "./connectCard.vue?vue&type=script&lang=js&"
export * from "./connectCard.vue?vue&type=script&lang=js&"
import style0 from "./connectCard.vue?vue&type=style&index=0&id=07340ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07340ff0",
  null
  
)

export default component.exports